import { useState } from 'react';

export default function useMobileItemForm({ isKanban }) {
  const [selectedItem, setSelectedItem] = useState(null);
  const [showDetail, setShowDetail] = useState(false);
  const [editing, setEditing] = useState(false);
  const [showAdd, setShowAdd] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const [addType, setAddType] = useState('task');
  const [addTitle, setAddTitle] = useState('');
  const [addDesc, setAddDesc] = useState('');
  const [addPoints, setAddPoints] = useState('');
  const [addAssignee, setAddAssignee] = useState('');
  const [addPriority, setAddPriority] = useState('medium');
  const [addParentId, setAddParentId] = useState(null);

  const [editTitle, setEditTitle] = useState('');
  const [editDesc, setEditDesc] = useState('');
  const [editType, setEditType] = useState('task');
  const [editPoints, setEditPoints] = useState('');
  const [editStatus, setEditStatus] = useState('not_started');
  const [editAssignee, setEditAssignee] = useState('');
  const [editPriority, setEditPriority] = useState('medium');
  const [editLocation, setEditLocation] = useState('backlog');

  const addForm = {
    type: addType, setType: setAddType,
    title: addTitle, setTitle: setAddTitle,
    desc: addDesc, setDesc: setAddDesc,
    points: addPoints, setPoints: setAddPoints,
    assignee: addAssignee, setAssignee: setAddAssignee,
    priority: addPriority, setPriority: setAddPriority,
    parentId: addParentId, setParentId: setAddParentId,
  };

  const editForm = {
    type: editType, setType: setEditType,
    title: editTitle, setTitle: setEditTitle,
    desc: editDesc, setDesc: setEditDesc,
    points: editPoints, setPoints: setEditPoints,
    status: editStatus, setStatus: setEditStatus,
    assignee: editAssignee, setAssignee: setEditAssignee,
    priority: editPriority, setPriority: setEditPriority,
    location: editLocation, setLocation: setEditLocation,
  };

  const openDetail = (item) => {
    setSelectedItem(item);
    setShowDetail(true);
    setEditing(false);
  };

  const startEditing = () => {
    setEditTitle(selectedItem.title);
    setEditDesc(selectedItem.description || '');
    setEditType(selectedItem.type);
    setEditPoints(selectedItem.storyPoints ?? '');
    setEditStatus(selectedItem.status);
    setEditAssignee(selectedItem.assigneeId || '');
    setEditPriority(selectedItem.priority || 'medium');
    setEditLocation(selectedItem.location || 'backlog');
    setEditing(true);
  };

  const openDirectEdit = (item) => {
    setSelectedItem(item);
    setEditTitle(item.title);
    setEditDesc(item.description || '');
    setEditType(item.type);
    setEditPoints(item.storyPoints ?? '');
    setEditStatus(item.status);
    setEditAssignee(item.assigneeId || '');
    setEditPriority(item.priority || 'medium');
    setEditLocation(item.location || 'backlog');
    setShowDetail(true);
    setEditing(true);
  };

  const resetAddForm = () => {
    setShowAdd(false);
    setAddTitle('');
    setAddDesc('');
    setAddPoints('');
    setAddAssignee('');
    setAddType('task');
    setAddPriority('medium');
    setAddParentId(null);
  };

  const closeDetail = () => {
    setShowDetail(false);
    setEditing(false);
    setSelectedItem(null);
  };

  const buildAddData = (location) => ({
    type: addType,
    title: addTitle.trim(),
    description: addDesc.trim(),
    storyPoints: addPoints === '' ? null : Number(addPoints),
    assigneeId: addAssignee || null,
    priority: isKanban ? addPriority : null,
    status: 'not_started',
    location,
    parentId: addParentId || null,
  });

  const buildEditData = (extraFields) => ({
    title: editTitle.trim(),
    description: editDesc.trim(),
    type: editType,
    storyPoints: editPoints === '' ? null : Number(editPoints),
    status: editStatus,
    assigneeId: editAssignee || null,
    priority: isKanban ? editPriority : null,
    ...extraFields,
  });

  return {
    selectedItem, setSelectedItem,
    showDetail, editing, showAdd, setShowAdd, showConfirm, setShowConfirm,
    addForm, editForm,
    openDetail, openDirectEdit, startEditing, resetAddForm, closeDetail, buildAddData, buildEditData,
  };
}
